import { createContext } from 'react';

/**
 * @deprecated
 */
const DeprecatedLayoutGroupContext = createContext(null);

export { DeprecatedLayoutGroupContext };
